import React, { useState } from 'react';
import Text from '../../../Base/Text/Text';
import Tooltip from '../../../Popup/Tooltip';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './RadioList.module.scss';

export interface RadioItemRenderItemProps {
	item: any;
	active: boolean;
}

export interface RadioListProps {
	data: RadioListItem[];
	value?: string | number;
	onChange?: any;
	inLine?: boolean;
	children?: React.ReactNode;
	renderItem?: (props: RadioItemRenderItemProps) => React.ReactElement;
}

export interface RadioListItem {
	title: string;
	value: string | boolean;
	text?: string;
	settings?: RadioListItemSettings;
}

interface RadioListItemSettings {
	tooltip: {
		content: any;
	};
}

const RadioList: React.FC<RadioListProps> = React.forwardRef<
	HTMLDivElement,
	React.PropsWithChildren<RadioListProps>
>(({ value, data, children, onChange, inLine = false, renderItem }, ref) => {
	const [checked, setChecked] = useState(value);

	const handleRadioItemClick = (item: RadioListItem) => {
		setChecked(item.value);
		onChange(item.value);
	};

	return (
		<>
			<div
				className={joinClasses([styles.wrapper, inLine && styles.inLine])}
				ref={ref}>
				{data.map((item, index) => (
					<div
						key={index}
						className={styles.radioWrapper}
						onClick={() => {
							handleRadioItemClick(item);
						}}>
						<div
							className={`${styles.radio} ${
								item.value == checked ? styles.active : ''
							}`}
						/>
						<div className={styles.wrapper2}>
							<>
								{renderItem ? (
									renderItem({
										item,
										active: item.value == checked,
									})
								) : (
									<Text
										className={styles.title}
										tx={item.title}
										inline
										firstUpper
									/>
								)}
								{item?.settings?.tooltip && (
									<Tooltip
										trigger={
											<img
												alt='info'
												className='ml-2'
												width='20px'
												src='/dist/icons/v2/circle-info-solid.svg'
											/>
										}
										customStyle={{ display: 'inline-block' }}>
										<Text tx={item.settings.tooltip.content} inline />
									</Tooltip>
								)}
							</>
						</div>
					</div>
				))}
			</div>
			{children}
		</>
	);
});

export default RadioList;
